// Ensure calls to console.log don't break IE
if (typeof console === "undefined" || typeof console.log === "undefined") {
  console = {};
  console.log = function() {};
}

var Octopus = window.Octopus = window.Octopus || {};



//////////////////
// WEBPACK FOOTER
// ./app/init.js
// module id = 712
// module chunks = 1